import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	downloadedReports: [],
	page: 1,
	maxPage: 1,
	total: 0,
};

const downloadedReportsSlice = createSlice({
	name: 'downloadedReports',
	initialState: initialState,
	reducers: {
		setDownloadedReports: (state, action) => action.payload,
		reset: (state, action) => initialState,
	},
});

export const { setDownloadedReports, reset } = downloadedReportsSlice.actions;

export default downloadedReportsSlice.reducer;